/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_RegionsInputs */

const en_manage_regions = /** @type {(inputs: Manage_RegionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Regions`)
};

const es_manage_regions = /** @type {(inputs: Manage_RegionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar regiones`)
};

/**
* | output |
* | --- |
* | "Manage Regions" |
*
* @param {Manage_RegionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const manage_regions = /** @type {((inputs?: Manage_RegionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_RegionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_regions(inputs)
	return es_manage_regions(inputs)
});